import type { ReactNode } from "react";
import { MenuItem, type MenuLink, type MenuStyles } from "./menu-item";

export function MenuGroup({
  heading,
  links,
  styles,
  onNavigate,
  children,
}: {
  readonly heading: string;
  readonly links: readonly MenuLink[];
  readonly styles: MenuStyles;
  readonly onNavigate: (href: string) => void;
  readonly children?: ReactNode;
}) {
  return (
    <li className={styles.group}>
      <span className={styles.heading}>{heading}</span>
      <ul className={styles.menu}>
        {links.map((link) => (
          <MenuItem
            key={link.href + link.label}
            link={link}
            styles={styles}
            onNavigate={onNavigate}
          />
        ))}
        {children}
      </ul>
    </li>
  );
}
